// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"376":"0f314bfba6e3b972","859":"614b7ac07c010b56","996":"05ba4784d7620156","997":"8951d0a8836702eb"}[chunkId] + ".js";
};